import faker from '@faker-js/faker';
import {TVerto, TTransaction, TWithdrawStatus, TGroupPlan} from './types';
import {TGroup, TGroupStatus, Verto} from '../types';
import {getKrakenPayoutList} from '../kraken/mock';
import {TKraken} from '../kraken/types';
import loopMap from 'mn-utils/loopMap';
import {TCurrency} from '@/types';

type TGroupPlanParams = {currency?: string};
export type TVertoGroupParams = {groupPlan?: TGroupPlanParams};
export const getVertoGroup = (params): TGroup<Verto> => {
  const krakenPayoutList = getKrakenPayoutList(faker.mersenne.rand(5, 1)) as TKraken[];
  const payoutList = getVertoList(faker.mersenne.rand(10, 1)) as TVerto[];
  const total = payoutList.reduce((acc, {amount}) => Number(acc += Number(amount)), 0);
  const statuses = [
    'FundsRequested',
    'FundsReceivedByNium',
    'FailedToTransferFunds',
    'PayoutsInProcess',
    'Complete',
    'Canceled',
  ] as TGroupStatus[];

  return {
    id: faker.datatype.uuid(),
    amount: String(total),
    fiat_code: faker.finance.currencyCode(),
    fee: faker.finance.amount(0, total, 2),
    expected_total_fees: faker.finance.amount(0, total, 2),
    kraken_withdraws: krakenPayoutList,
    flow: 'v2_via_verto_direct',
    flow_details: {
      group_plan: getVertoGroupPlan(),
      payouts: payoutList,
    },
    mode: (faker.helpers as any).arrayElement(['Manual', 'Auto']) as 'Manual' | 'Auto',
    status: (faker.helpers as any).arrayElement(statuses) as TGroupStatus,
    errors: [],
    created_at: faker.date.recent().toISOString(),
  } as TGroup<Verto>;
};

export const getVertoGroupPlan = (): TGroupPlan => {
  const exchangeList = ['kraken'];

  return {
    id: faker.datatype.uuid(),
    currency: faker.finance.currencyCode(),
    fee: faker.finance.amount(0, 1000, 2),
    amount: faker.finance.amount(0, 1000, 2),
    exchange: (faker.helpers as any).arrayElement(exchangeList),
  };
};

export const getVertoList = (limit: number = 5): TVerto[] => {
  const currency = faker.finance.currencyCode();
  return loopMap(limit, () => getVerto(currency)) as TVerto[];
};

export function getVerto(currency: TCurrency): TVerto {
  const statuses = ['initiated', 'pending', 'completed', 'failed'] as TWithdrawStatus[];

  return {
    id: faker.datatype.uuid(),
    account_id: faker.datatype.uuid(),
    merchant_name: faker.name.findName(),
    merchant_email: faker.internet.email(),
    bank_id: faker.datatype.uuid(),
    fiat_code: currency || faker.finance.currencyCode(),
    amount: faker.finance.amount(0, 1000, 2),
    created_at: faker.date.recent().toISOString(),
    status: (faker.helpers as any).arrayElement(statuses),
    ...(faker.datatype.boolean() ? {description: faker.lorem.lines(faker.mersenne.rand(10))} : {}),
    ...(faker.datatype.boolean() ? {tx: getVertoTransaction()} : {}),
  } as TVerto;
}

export function getVertoTransaction(): TTransaction {
  const amount = faker.finance.amount(0, 1000, 2);
  return {
    id: faker.datatype.uuid(),
    verto_id: faker.datatype.uuid(),
    withdraw_id: faker.datatype.uuid(),
    amount,
    fee: faker.finance.amount(0, Number(amount), 2),
    currency: faker.finance.currencyCode(),
    created_at: faker.date.recent().toISOString(),
    fx_rate: faker.finance.amount(0, Number(amount), 2),
  } as TTransaction;
}
